<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-9">
        {{ $t(switchTitle) }}
      </h3>
      <div class="mb-9 flex items-center justify-center w-full">
        <div class="w-16 h-16 bg-gray-500 rounded-full flex items-center justify-center text-white text-3xl">
          {{ firstNameInitial }}
        </div>
        <img
          class="m-5 m-12"
          src="@/assets/svg/icon_48px_transfer.svg"
          alt="switch account"
        >
        <div
          class="relative w-16 h-16 bg-red-500 rounded-full flex items-center justify-center text-white text-3xl"
        >
          <img
            :src="loginIcon"
            class="absolute w-8 h-8 top-12 left-16 transform -translate-x-1/2 -translate-y-1/2 rounded-full bg-white"
            alt="login"
          >
          {{ firstNameInitial }}
        </div>
      </div>
      <div class="confirm-message ml-6 mr-6 mb-5">
        {{ $t(confirmMessage) }}
      </div>
      <div class="ml-6 mr-6 mb-9 flex">
        <div class="flex flex-shrink-0 mycheckbox">
          <input
            id="confirmCheckbox"
            v-model="isCheckboxChecked"
            type="checkbox"
            class="opacity-0 absolute h-8 w-8"
          >
          <div :class="[{ 'border-zyxel-green-500': isCheckboxChecked, 'border-gray-800': !isCheckboxChecked }, 'border-2 w-6 h-6 rounded-md']" />
        </div>
        <label
          for="confirmCheckbox"
          class="ml-2"
        >{{ $t(checkMessage) }}</label>
      </div>
      <div class="hidden sm:flex justify-end space-x-2 mr-6 mb-9">
        <button
          class="min-w-[120px] button-cancel"
          @click="cancel"
        >
          {{
            $t('messages.button.cancel') }}
        </button>
        <button
          :disabled="!isCheckboxChecked"
          class="min-w-[120px] button-primary"
          @click="confirm"
        >
          {{
            $t('messages.button.switch') }}
        </button>
      </div>
      <div class="flex-col sm:hidden mb-4 p-4">
        <button
          :disabled="!isCheckboxChecked"
          class="button-primary w-full mb-4"
          @click="confirm"
        >
          {{
            $t('messages.button.switch') }}
        </button>
        <button
          class="button-cancel w-full"
          @click="cancel"
        >
          {{
            $t('messages.button.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';

export default {
    props: ['isVisible', 'login_method'],
    data() {
        return {
            isCheckboxChecked: false,
        };
    },
    computed: {
        loginIcon() {
            if (this.login_method === 'Apple') {
                return require("@/assets/svg/icon_48px_Apple.svg");
            }

            // default google
            return require("@/assets/svg/icon_48px_Google.svg");
        },
        confirmMessage() {
            if (this.login_method === "Apple") {
                return this.$t('messages.switch_account_modal.description_apple', { email: this.email });
            }

            // default google
            return this.$t('messages.switch_account_modal.description_google', { email: this.email });
        },
        checkMessage() {
            if (this.login_method === "Apple") {
                return "messages.switch_account_modal.checkbox_apple";
            }
            return "messages.switch_account_modal.checkbox_google";
        },
        switchTitle() {
            if (this.login_method === "Apple") {
                return "messages.switch_account.title_apple";
            }
            return "messages.switch_account.title_google";
        },
        firstNameInitial() {
            const authStore = useAuthStore();
            return authStore.getFirstNameInitial();
        },
        email() {
            const authStore = useAuthStore();
            return authStore.getEmail();
        }
    },
    methods: {
        confirm() {
            if (this.isCheckboxChecked) {
                this.$emit('confirm');
            }
        },
        cancel() {
            this.$emit('cancel');
            this.$emit('update:isDialogVisible', false);
        }
    }
}
</script>